const WORKSHOP_ID = /^[a-f0-9]{16}$/i;
export const INSTALLATION_GROUPS = ['Required by Current Scenario', 'Optional/User Installed', 'Unknown'];

export function canonicalScenarioId(value) {
  return typeof value === 'string' ? value.replace(/^\{([a-f0-9]{16})\}/i, (_, id) => `{${id.toUpperCase()}}`) : '';
}

export async function resolveInstalledMods(config, getItem, getDependencies) {
  const scenarioId = config?.game?.scenarioId;
  const match = typeof scenarioId === 'string' && scenarioId.match(/^\{([a-f0-9]{16})\}Missions\/.+\.conf$/i);
  if (!match) return { status: 'unknown', metadata: new Map(), required: new Set(), message: 'Current Scenario ID is unavailable or invalid. Installation reasons are unknown.' };
  const ids = [...new Set((config.game.mods ?? []).map(mod => String(mod.modId || '').toUpperCase()).filter(id => WORKSHOP_ID.test(id)))];
  // The resource GUID is only a candidate if it is installed as a Workshop mod.
  const candidates = [...ids.filter(id => id === match[1].toUpperCase()), ...ids.filter(id => id !== match[1].toUpperCase())];
  const metadata = new Map();
  let root;
  for (const id of candidates) {
    try {
      const item = await getItem(id);
      if (!Array.isArray(item?.scenarios)) throw new Error('Invalid item response');
      metadata.set(id, item);
      if (item.scenarios.some(scenario => canonicalScenarioId(scenario.scenarioId) === canonicalScenarioId(scenarioId))) {
        root = id;
        break;
      }
    } catch {
      // Failed metadata does not block finding the scenario in another item.
    }
  }
  if (!root) return { status: 'unknown', metadata, required: new Set(), message: 'The current scenario could not be matched to an installed Workshop item. Installation reasons are unknown.' };
  try {
    const dependencies = await getDependencies(root);
    if (!Array.isArray(dependencies) || dependencies.some(mod => !WORKSHOP_ID.test(mod?.workshopId || ''))) {
      throw new Error('Invalid dependency response');
    }
    const required = new Set([root]);
    dependencies.forEach(mod => {
      const id = mod.workshopId.toUpperCase();
      required.add(id);
      metadata.set(id, mod);
    });
    return { status: 'resolved', metadata, required };
  } catch {
    return { status: 'unknown', metadata, required: new Set(), message: 'Current scenario dependencies could not be loaded. Installation reasons are unknown.' };
  }
}

export function groupInstalledMods(mods, intelligence) {
  const groups = Object.fromEntries(INSTALLATION_GROUPS.map(group => [group, []]));
  mods.forEach(mod => {
    const id = String(mod.modId || '').toUpperCase();
    const group = intelligence.status !== 'resolved' || !WORKSHOP_ID.test(id)
      ? 'Unknown' : intelligence.required.has(id) ? 'Required by Current Scenario' : 'Optional/User Installed';
    groups[group].push(mod);
  });
  return groups;
}
